var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7288 3.95352L3.18805 11.4843C3.22367 12.0604 3.7113 12.5238 4.31961 12.5238H9.43133C10.0267 12.5238 10.5095 12.0795 10.5617 11.5176L11.2537 3.9524C9.98749 3.87142 8.3 3.78252 7 3.78252C5.69402 3.78252 3.99696 3.87224 2.7288 3.95352ZM12.3942 4.0304C12.5175 4.03939 12.6261 4.04749 12.7176 4.05442C12.8236 4.06244 12.9066 4.0689 12.9631 4.07334L13.0487 4.08015C13.3632 4.10569 13.6392 3.87142 13.6648 3.55687C13.6903 3.24231 13.456 2.9666 13.1415 2.94106L13.0527 2.934C12.9952 2.92948 12.9111 2.92294 12.8039 2.91482C12.5897 2.8986 12.2836 2.87608 11.9152 2.85086C10.6262 2.76257 8.55506 2.63966 7 2.63966C5.44494 2.63966 3.37385 2.76257 2.08479 2.85085C1.71642 2.87608 1.41028 2.8986 1.19606 2.91482C1.08894 2.92294 1.00479 2.92948 0.947299 2.934L0.858977 2.94102C0.544422 2.96657 0.309693 3.24231 0.335238 3.55687C0.360783 3.87142 0.636484 4.10571 0.951037 4.08017M0.951037 4.08017L1.03691 4.07334C1.09337 4.0689 1.17642 4.06244 1.28236 4.05442C1.36962 4.04781 1.47238 4.04014 1.58859 4.03166L2.04734 11.5542C2.121 12.7487 3.12305 13.6667 4.31961 13.6667H9.43133C10.6012 13.6667 11.5919 12.7882 11.6997 11.6225L12.3942 4.0304",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93334 1.47623C5.82814 1.47623 5.74286 1.56151 5.74286 1.66671V2.88164C5.74286 3.19723 5.48703 3.45307 5.17144 3.45307C4.85585 3.45307 4.60001 3.19723 4.60001 2.88164V1.66671C4.60001 0.930328 5.19696 0.333374 5.93334 0.333374H8.06666C8.80304 0.333374 9.39999 0.930329 9.39999 1.66671V2.88164C9.39999 3.19723 9.14415 3.45307 8.82856 3.45307C8.51297 3.45307 8.25714 3.19723 8.25714 2.88164V1.66671C8.25714 1.56151 8.17186 1.47623 8.06666 1.47623H5.93334Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99053 2.88165C3.99053 2.56606 4.24636 2.31022 4.56195 2.31022L5.781 2.31022C6.09659 2.31022 6.35242 2.56606 6.35242 2.88165C6.35242 3.19725 6.09659 3.45308 5.781 3.45308H4.56195C4.24636 3.45308 3.99053 3.19725 3.99053 2.88165Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6476 2.88165C7.6476 2.56606 7.90344 2.31022 8.21903 2.31022H9.43807C9.75366 2.31022 10.0095 2.56606 10.0095 2.88165C10.0095 3.19725 9.75366 3.45308 9.43807 3.45308H8.21903C7.90344 3.45308 7.6476 3.19725 7.6476 2.88165Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.60496C7.31559 5.60496 7.57143 5.8608 7.57143 6.17639V10.1301C7.57143 10.4457 7.31559 10.7015 7 10.7015C6.68441 10.7015 6.42858 10.4457 6.42858 10.1301V6.17639C6.42858 5.8608 6.68441 5.60496 7 5.60496Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56195 6.26388C4.87754 6.26388 5.13338 6.51972 5.13338 6.83531V9.47109C5.13338 9.78668 4.87754 10.0425 4.56195 10.0425C4.24636 10.0425 3.99053 9.78669 3.99053 9.47109V6.83531C3.99053 6.51972 4.24636 6.26388 4.56195 6.26388Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43805 6.26388C9.75364 6.26388 10.0095 6.51972 10.0095 6.83531V9.47109C10.0095 9.78668 9.75364 10.0425 9.43805 10.0425C9.12246 10.0425 8.86662 9.78669 8.86662 9.47109V6.83531C8.86662 6.51972 9.12246 6.26388 9.43805 6.26388Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b7667274.svg";
export { ForwardRef as ReactComponent };